import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    party: [],
    drink_list: [],
    menu_data: [],
    party_id: "",
    email_address: "",
    attendance: "",
    business_name: "",
    last_name: "",
    first_name: "",
    last_name_kana: "",
    first_name_kana: "",
    phone: "",
    postal_code: "",
    prefecture: "",
    city: "",
    address1: "",
    address2: "",
    address_note: "",
    delivery_date: "",
    delivery_time: "",
    menu_id: "",
    menu_name: "",
    drink_group_id: "",
    drink_group_name: "",
    confirmation: false,
    complete: false,
    attendance_deadline_date: "",
};

// 参加登録URLチェック
export const GetMemberForm = function (arg = {}) {
    console.log(arg);
    const params = {
        url: "/api/GetMemberForm",
        method: "get",
        params: { ...arg },
        type_name: "メンバーフォーム取得",
    };
    return AsyncFunction(params);
};

// 参加登録
export const UpdateAttendance = function (arg = {}) {
    const params = {
        url: "/api/UpdateAttendance",
        method: "put",
        params: { ...arg },
        type_name: "UpdateAttendance",
    };
    return AsyncFunction(params);
};

// Sliceを生成する
const slice = createSlice({
    name: "MemberForm",
    initialState,
    reducers: {
        MemberFormSet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },

    extraReducers: (builder) => {
        builder.addMatcher(
            (action) => action.type.match("メンバーフォーム取得") && action.type.endsWith("/fulfilled"),
            (state, action) => {
                const payload = action.payload;
                state.party = payload.party;
                state.party_id = payload.party?.party_id;
                state.drink_list = payload.drink_list;
                state.menu_data = payload.menu_data;
                
            }
        );
    },
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { MemberFormSet } = slice.actions;
